// removed by extract-text-webpack-plugin
module.exports = {"data-pane":"data-pane__data-pane","current-dataset":"data-pane__current-dataset","data-pane-section":"data-pane__data-pane-section","data-pane-title":"data-pane__data-pane-title"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-pane/data-pane.scss
// module id = 1211
// module chunks = 0